import React from 'react';
import withDraggable from '~app/core/withDraggable';

function LabelBankLabel({ label, grabbed }) {
  return (
    <div role="listitem" className="LabelBank__item">
      <div
        className="canvas__label handle"
        role="button"
        tabIndex={0}
        aria-dropeffect={grabbed ? 'move' : 'none'}
        aria-grabbed={grabbed}
      >
        <div className="canvas__label__text">{label}</div>
      </div>
    </div>
  );
}

export default withDraggable(LabelBankLabel, {
  draggableProps: { handle: '.handle' },
});
